import Win2kButton from "@/components/win2k/Win2kButton";
import { cn } from "@/lib/utils";

interface GameOverScreenProps {
  winners: string[];
  scores: Record<string, number>;
  playerOrder: string[];
  myUsername: string;
  onBackToLobby: () => void;
}

export default function GameOverScreen({
  winners,
  scores,
  playerOrder,
  myUsername,
  onBackToLobby,
}: GameOverScreenProps) {
  const sorted = [...playerOrder].sort(
    (a, b) => (scores[b] ?? 0) - (scores[a] ?? 0)
  );

  const isTie = winners.length > 1;
  const isWinner = winners.includes(myUsername);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="win2k-outset bg-[var(--win2k-window-bg)] max-w-sm w-full mx-4">
        <div className="win2k-title-bar px-1 py-0.5 min-h-[22px]">
          <span className="text-xs font-bold">Game Over</span>
        </div>

        <div className="p-4 space-y-4">
          <div className="text-center space-y-1">
            <div className="text-2xl font-pixel">
              {isWinner ? "You Win!" : isTie ? "It's a Tie!" : "Game Over"}
            </div>
            <div className="text-[12px] text-[var(--win2k-button-text)]">
              {isTie
                ? `${winners.join(" & ")} tied for the win!`
                : `${winners[0]} wins the game!`}
            </div>
          </div>

          <fieldset className="win2k-inset p-2">
            <legend className="text-[11px] font-bold px-1">Final Scores</legend>
            <div className="space-y-1">
              {sorted.map((username, i) => {
                const isChampion = winners.includes(username);
                const isMe = username === myUsername;

                return (
                  <div
                    key={username}
                    className={cn(
                      "flex items-center gap-2 px-1.5 py-1 text-[12px]",
                      isChampion && "bg-[var(--win2k-title-blue-start)] text-white font-bold",
                      !isChampion && isMe && "bg-[var(--win2k-highlight)] text-[var(--win2k-highlight-text)]"
                    )}
                  >
                    <span className="w-5 text-center font-mono text-[11px]">
                      {i === 0 ? "\u{1F3C6}" : `#${i + 1}`}
                    </span>
                    <span className="flex-1 truncate">{username}</span>
                    <span className="font-mono tabular-nums">
                      {scores[username] ?? 0} pts
                    </span>
                  </div>
                );
              })}
            </div>
          </fieldset>

          <div className="flex justify-center">
            <Win2kButton onClick={onBackToLobby} className="min-w-[140px]" autoFocus>
              Back to Lobby
            </Win2kButton>
          </div>
        </div>
      </div>
    </div>
  );
}
